<template>
  <div 
    class="filters-container"
    v-bind:style="{ height: filtersHeight + 'px !important', maxHeight: filtersHeight + 'px !important' }"
  >
    <v-treeview
      v-if="privateCollections.length > 0"
      class="private-treeview"
      hoverable
      open-on-click
      selectable
      :items="privateCollections"
      item-children="__children"
      @input="selectPrivateCollections"
      :value="selectedPrivate"
    ></v-treeview>
    <p v-else><i>Aucune collection privée</i></p>

    <v-divider></v-divider>

    <h4 class="mt-5">Collections générales</h4>
    <v-treeview
      v-if="publicCollections.length > 0"
      hoverable
      open-on-click
      selectable
      :items="publicCollections"
      item-children="__children"
      @input="selectPublicCollections"
      :value="selectedPublic"
    ></v-treeview>
    <p v-else><i>Aucune collection publique</i></p>

    <v-divider></v-divider>
    
    <h4 class="mt-5">Catégories supports</h4>
    <v-treeview
      v-if="categories.length > 0"
      hoverable
      open-on-click
      selectable
      :items="categories"
      item-children="__children"
      @input="selectCategory"
      :value="selectedCategories"
    ></v-treeview>
    <p v-else><i>Aucune catégorie support</i></p>
  </div>
</template>

<script>
  // EVENTS
  import { EventBus } from '@/main'
  import { LOADING, LOADED, SET_PRIVATE_COLLECTIONS, SET_PUBLIC_COLLECTIONS, SET_CATEGORIES } from '@/store/actions/general'
  import { SELECT_CATEGORY, SELECT_COLLECTION } from '@/store/actions/references'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const ReferencesRepository = RepositoryFactory.get('references')

  export default {
    name: 'Collections',

    data: () => ({
      privateCollections: [],
      publicCollections: [],
      categories: [],
      isLoading: true,
      selectedPrivate: [],
      selectedPublic: [],
      selectedCategories: [],
      filtersHeight: 300,
    }),
    
    computed: {
      selectedCollections() {
        return [...this.selectedPrivate, ...this.selectedPublic]
      }
    },

    methods: {
      async getCollections() {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await ReferencesRepository
          .getReferencesCollections('public', customerApiToken)
          .then(response => {
            this.isLoading = false
            this.publicCollections = response.data
            // EventBus.$emit(LOADED)
          })
          .catch(error => {
            
          })
        this.privateCollections = [
          { __children: [], description: 'Votre collection', id: 'private', name: 'Votre collection', 'slug': 'votre-collection' },
          { __children: [], description: 'Nouveautés', id: 'new', name: 'Nouveautés', slug: 'nouveautes' },
        ]

        this.initFilters()
      },
      selectPrivateCollections(items) {
        this.selectedPrivate = items
        this.$store.commit(SET_PRIVATE_COLLECTIONS, items)
        this.$emit(SELECT_COLLECTION, this.selectedCollections)
      },
      selectPublicCollections(items) {
        this.selectedPublic = items
        this.$store.commit(SET_PUBLIC_COLLECTIONS, items)
        this.$emit(SELECT_COLLECTION, this.selectedCollections)
      },
      selectCategory(items) {
        this.$store.commit(SET_CATEGORIES, items)
        this.$emit(SELECT_CATEGORY, items)
      },
      initFilters() {
        this.selectedPrivate    = this.$store.getters.getPrivateCollections
        this.selectedPublic     = this.$store.getters.getPublicCollections
        this.selectedCategories = this.$store.getters.getCategories

        this.$emit(SELECT_COLLECTION, this.selectedCollections)
        this.$emit(SELECT_CATEGORY, this.selectedCategories)
      },
      async getCategories() {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await ReferencesRepository
          .getReferencesCategories(customerApiToken)
          .then(response => {
            this.isLoading = false
            this.categories = response.data
            // EventBus.$emit(LOADED)
            this.filtersHeight = window.innerHeight - 125
          })
          .catch(error => {
            
          })
      },
      height() {
        return window.innerHeight
      },
    },
    
    created() {
      this.getCollections()
      this.getCategories()
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .private-treeview .v-treeview-node__level {
    width: 0 !important;
  }

  .filters-container {
    overflow-y: scroll;
    min-width: 282px;
  }

  @media (min-width: 960px) {
    .filters-container {
      position: sticky;
      top: 70px;
    }
  }

  .filters-container::-webkit-scrollbar-track {
    background-color: #F5F5F5;
  }

  .filters-container::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }

  .filters-container::-webkit-scrollbar-thumb {
    background-color: $primary-color;
    border-radius: 10px
  }
</style>